module.exports = __webpack_public_path__ + "media/dashboard/assets/images/lavel_logo_placeholder-1b22c8c19b29dada309135f818dcd9b5.png";